var _defs, _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReactLogoPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 92 82.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#262B40;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48,68C22.2,68,2,59.2,2,48S22.2,28,48,28s46,8.8,46,20S73.8,68,48,68Zm0-36C22.8,32,6,40.2,6,48S22.8,64,48,64s42-8.2,42-16S73.2,32,48,32Z",
    transform: "translate(-2 -6.9)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.2,89.2A9.24,9.24,0,0,1,25,87.8c-9.8-5.6-7.2-27.4,5.6-49.8h0c6-10.4,13.4-19.2,20.6-24.8,7.8-6,14.8-7.8,19.6-5,5,2.8,6.8,9.8,5.6,19.6-1.2,9.2-5.2,20-11.2,30.4S51.8,77.4,44.6,83C39.4,87,34.4,89.2,30.2,89.2ZM65.8,10.8c-3.2,0-7.4,1.8-12,5.4C47,21.6,40,30,34.2,40h0C21.6,61.8,20.4,80.6,27,84.4c3.4,2,9,.2,15.2-4.6C49,74.4,56,66,61.8,56s9.6-20.2,10.8-28.8c1-8-.2-13.6-3.6-15.6A8.39,8.39,0,0,0,65.8,10.8Z",
    transform: "translate(-2 -6.9)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66,89.2C56,89.2,41.6,77,30.8,58,17.8,35.6,15.2,13.8,25,8.2h0C34.8,2.6,52.4,15.6,65.4,38c6,10.4,10,21.2,11.2,30.4C78,78.2,76,85,71,88A10.84,10.84,0,0,1,66,89.2ZM27,11.6c-6.6,3.8-5.4,22.6,7.2,44.4S62.4,88.2,69,84.4c3.4-2,4.6-7.6,3.6-15.6C71.4,60.2,67.6,50,61.8,40,49.2,18.2,33.6,7.8,27,11.6Z",
    transform: "translate(-2 -6.9)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 46,
    cy: 41.1,
    r: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactLogoPrimary);
export default __webpack_public_path__ + "static/media/react-logo-primary.5760e58fc2a2e3a36c6e83b84a35062e.svg";
export { ForwardRef as ReactComponent };